// This file is automatically @generated by scripts/generate-json-schema/index.ts

export const sessionStorageVersions: { readonly [key: string]: string } = {
  academyCategories: 'fb670d0a0bce7a40e6d3e1866599b496',
  academyCourses: 'daa590ef35214f5e040f2bd6ee34412a',
  academyInstructors: '6f4a29e8301b4de6ba957be8a227331b',
  academyLessons: 'def9dd292a20a515a8e833080e617979',
  academyModules: 'db5a8b4e3d5d31db4f7706783b6e3d40',
  academyPriceTiers: '8f9b15b484a31e0d60ea7001b3c61961',
  accountProgress: '3688d6e7dc0acbb3fa916977d4639d93',
  applicationScopes: '9947a1a7d3aef85aebd2999eac5c31b8',
  agents: 'a265dd72d416c2e07efd47b7b136ad2c',
  agentSessions: 'c165fdd44849a7b2ce06a51207841434',
  allProjects: '667afd3681042d16d16a8e5b955239a8',
  banners: '32c82d12d5c598fd6b14b7964b5838a8',
  bidAwardRevokeReasons: '64acf7c4c868f9dbcb96f165f6152f33',
  bidBuyerProjectFees: '1fe413c25bf07f0f2c6c9a525a43b20d',
  bidEditRequests: '3adb4df25e6f2abbe24ddd9c4782d4a4',
  bidRatings: '79165c6e4378ec4106df9d0e76daeb3e',
  bids: '7867d9b7676904166d2011a13baa9427',
  bidUpgradeFees: '4579a27fe5872b4df1b9cf24f9c53d57',
  billingAgreements: '6aff8760dae9a8c9b439ce3ba1f2919c',
  cartItems: 'd7e644ef2b74da6880c36c9077117702',
  carts: '04dab66fc081c92d5a5e263d3514911d',
  certifications: '43fd8862311f73a91a22f2e897799065',
  contacts: '158d4260fd8c62fbe4d8052e24f8b5c4',
  contestBudgetRanges: '68ec769e2457359239fdcc61ad36f041',
  contestEngagement: 'a5593474fb4fe13cf7ff54a2b5dcacda',
  contestEntries: '9fc5f8a3bc62bac260b86749b1c8c1eb',
  contestEntryMessages: 'd9fc3e2b1c066a75eae1f70644b5e662',
  contestFees: '12a03576c5a766a03818e2a660483e90',
  contestFiles: 'abe08370d1fcbb188064e2fc20abf5f7',
  contestHandovers: '9ac9b70b0f42d6f0f2f079df0e8437ce',
  contestInterestedFreelancers: 'c43f3df6657d87978a841360838e64d2',
  contestMessages: '623bd4c8ee11fb64479d0705d6313602',
  contestMinimumBudgetClassifications: '5927f1833074f51a601116d91011d5e1',
  contestHasInvoices: 'da0535723aa640de1eae01ebdd336341',
  contests: '5673a8794d75b6f0dec4565666e10b5d',
  contestViewContests: '719d5517cc2a30c6a7ebe8dba2a9847b',
  contestViewEntries: '0b61963d71a44dea9b8d7ed8f979f41b',
  contestViewEntryIds: 'c675b0fd2ab3104e632665b8acbf7c48',
  contestQuickviewEntries: 'c4b52c5a220e47c235d1f7a58c344f6d',
  countries: '31f2bba0d5f522a2cdc070e42c294e8a',
  currencies: '7de9b2df5bf61db45209b0276ae15363',
  currenciesIncludingExternal: '7de9b2df5bf61db45209b0276ae15363',
  dashboardPolls: '4a5ec8404c9cc72f492206255a087633',
  dashboardWidgets: '47db5a7df92772b22a46b9a35aff6594',
  deloitteSubscriberEmails: '1c0091df229fdc72087ecdc965f702a0',
  deloitteUserInfo: '6f940769d6f4aad061a8ffae7ad86b63',
  depositFees: '85dc2b2a2031be813a9643266a4dd010',
  depositPageVars: '10745ad12dfa11c2d7857d8c38cd00ee',
  developerApplications: '937e94bb45e2b2d0c548490d1e4237a9',
  discoverCollections: 'b6c5537b17ad7c0c7810babc4b9fd056',
  discoverCollectionItems: 'd49ecd957990be88a5c0146f9b819efc',
  domains: 'c0e06272e05d594cf6702b5419ed5243',
  driveFilePermissions: 'c0cff6c7d2029832d4642533a723540d',
  driveFiles: '724a2a8039a094de4f884ff49b4df8e3',
  educations: '4e4d2de15feb9cc47ee71696c7c84ad8',
  emailIsAvailableForArrow: 'a0ddf5b621669626a62f47df472f3a87',
  employerReputationsRehireRates: '3cebc056801046cf1be2c88ddc8d791d',
  encodedUrl: 'a86dacdcfe22e36258a0ec0a180fcd6f',
  exchangeRates: 'f83b34c90a913ca6e474c7386150b771',
  experiences: '952b032c9d96f20d256df0f779322a87',
  freelancerReputations: '3cebc056801046cf1be2c88ddc8d791d',
  freelancerReputationsRehireRates: '3cebc056801046cf1be2c88ddc8d791d',
  hiremeCounteroffers: '01f09946ca292605b754886da54f72cf',
  hourlyContracts: '81b362465ff0f0e19ee711f118ac5791',
  hourlyProjectMilestoneFees: '06d688f2a842f625af0fb0e8fa3c9b30',
  invoices: '0c0fa0bc460bc87f6acca4b207928e20',
  ipContracts: 'b4a6b468834bdbcf9db8cb825d8913f2',
  issuingInstitution: '95b335961666b09b4cf2b3207794d307',
  jobClassifier: 'be13e9b8247389acf7d14f58d02098f6',
  languageDetect: '8396cfb5cbcb3c8df3a922741007716c',
  languages: 'b5e1f3de9dae5b4c1526d475397a9bcd',
  membershipBenefits: '35e0ee8c6f67d33168c1cdb83aa7e531',
  membershipDowngrades: '5e55af3581868b7b8e293b90768eadb8',
  membershipSubscriptions: '0c4efaf0be704e7d0f20a57f3a6fade5',
  messageAttachments: '651faffef24bfb290da9076ef4094f1e',
  messages: '36654931839897621790bd305acaf33c',
  milestoneDrafts: 'ed83b1532fab3e99ea4948b61895670d',
  milestoneRequests: '7b498c09562630fbc2eb86943110d54d',
  milestones: 'dd4c206df0c2df32b10e9eb36b6cd9f5',
  modifyBidSellerFees: '403c3613ac89c1de9cf84c3c7455df3e',
  nativeExchangeRates: 'f83b34c90a913ca6e474c7386150b771',
  nearbyProjects: '38cd7a0997c782632c26a6078ec8a735',
  newsfeed: '5bddf4db81a5c55255e0541625bf234d',
  nextPreviousUsers: '7b59c6479775e199046719f3797eb497',
  notifications: '01c3c77539762a396972f2c015e8ba57',
  notificationsPreferences: '707e41567df79de7d3093d607f53368a',
  onBehalfProjects: '85a137ef118a0c31ea1ba611be5a083f',
  onlineOffline: 'c8e6e68cd993759dac49382b61a1ac64',
  pfSupportTickets: '1c736a0679b47a2f92fee2888149c236',
  pjpAssistantEnqueue: '9d60ace685ca5972b1967be2059d8bcc',
  portfolios: '3c40ea345b4f366f0803500eb4c46bf8',
  postJobPageFormState: '2920557eb0379f12d033dfedb3d7f7c0',
  predictedSkills: '724d5f18f98df47a7253837e1d03c9a6',
  profileCategories: '3fb086b1a1f4e6739e18207a33db1c31',
  profileViewUsers: 'a943fc2009f17fda13d344a1c24edb8d',
  projectInvite: 'e0d5e878b75f9ffb0d4a185d388b6030',
  projectBidInfo: '9ae867bad0f9e3aa4447f38e2aed2e6b',
  projectBookmarks: '94b358c99f7d89310f719640a163581c',
  projectBudgetOptions: 'fe3aa365c616fb43e1da48afcc2f130d',
  projectCollaborations: '47de2c84d4c059dbd46a9e54f2e8b465',
  projectFeed: 'ebfb0b0cc6c9f19952c84352c84b969c',
  projectFeedFailingContests: 'ebfb0b0cc6c9f19952c84352c84b969c',
  projectFeedFailingProjects: 'ebfb0b0cc6c9f19952c84352c84b969c',
  projectFeeInfo: '141ae845bb7bcbec6f8b1c39d825b7f2',
  projectOffer: '7f26ad3000909c270de718570960cc58',
  projects: '8c340c3f9d2385bd79c578d78a682742',
  projectUpgradeFees: '0186a0b393731d70225b3172e4e83014',
  projectViewBids: '93f7a72c945dd2d14ba6520919b98dd5',
  projectViewProjects: 'c985b3bea4727f3f4e8e4dae62ab40bd',
  projectViewUsers: '9d44d4f374e86281af203a49a3beb2bd',
  publications: '32798a1bbd15853ddb6ec4f76fa43f97',
  recruiterOptOut: 'f7106ebbf3e60c1a6fa980bcf70ae004',
  referralInvitationCheck: '24eddef86909e002dd9ee8cded56f8d2',
  referralInvitations: '61348e34ac68a8f8c437f8d0f33eddf9',
  reviews: 'bf070f7af04c0047f56f08b7a7b92e46',
  searchHistory: '7a826dfd6e549968829c4e407125bb5d',
  searchMyContacts: 'e62414e4cf126c78a96d0bd3b10ac132',
  searchMyProjectsBuyer: 'c1c4c45e381ac26d2254b5cb5afa7f23',
  showcase: '18adf43194b5889bd466ed83c48af3fc',
  showcaseSource: '528a53ba8ced968954a3585a5225a22c',
  similarFreelancers: 'a94c2497773696df7c26be74e2ff7530',
  similarShowcases: 'a94c2497773696df7c26be74e2ff7530',
  skills: 'b0b9d47616e234db600127beb4ebf884',
  suggestedSkills: '74db00b149426fa76661ddd86621e02d',
  tagFamilyMembers: 'bec8b904ff3c95ce66f8f068ad560215',
  tagProperties: 'c921ffb9aa46d085b4828622489c8d71',
  tags: 'bcf4ea4b24fd7c420e375e6a3e865817',
  tasks: '01c5cb8d0996464fe2f088daf4d4e359',
  tax: '09e8975a9499f263c33cb9db2747c307',
  teamMembers: 'bb6a0e0816be6616cd7e94e9d7cb3386',
  teams: '2683231453ddb11b5b8781fbae14592a',
  testing: '26c562fe7058803b53d1db7116494963',
  threadProjects: '8f81c17e27ef633bb2895c677faa12ff',
  threads: 'ba8ab8a01e6b6d24f13be543b8344ea7',
  threadUsers: 'dcc043a2d2c0e1f6b7fd52e66441232e',
  timeTrackingPunches: 'a86fa2830faaceb3958281ddcd8da60e',
  timeTrackingSession: 'afd7dcc3791c3071706c3f11df175ed9',
  timeTrackingSessionAggregate: 'c21f646077e99cb71252ac21e55dab7e',
  toastNotifications: '44a7338298bb163c43bba32f80794549',
  topSkills: '88edbb1b65d6031c7e16fea85f5e9c86',
  transactionHistoryDetails: '2c9bcefdc7a6d4094ed734f28c4ca093',
  transactionHistoryItems: '584221b11640fef828f038a3bcd4d357',
  universities: '6864ec0a4d30b810ff1df4e3433ea339',
  usStates: 'f251a17954a572d64b9400e2e94b9ded',
  userBalances: 'ac222b4645e3d514e8b493905d12f8f1',
  userBidLimit: 'bbd8ee874d96afa7257b9e5dd2604c55',
  userCalifornianStatuses: '811b21828faa5a88aee50fa30d9cfc63',
  userDepositMethods: 'f49d9cf97d9c96227a57a4a3a6d997bf',
  userGiveGetDetails: 'd111cdcfd30887f43734ba920b81f71e',
  userHasGivenFeedback: '9da27991064a86ae00666fdfb61bf052',
  userInfo: 'ae25ad5d3245013270ae30f0ff6dafcf',
  userInsignias: 'e393f744166ee2426b598923634c9f7e',
  userInteractions: 'b69a5eaa43726f0eae83d0348f44abf6',
  userIsArrowWhitelisted: 'd57f78c922d51723060e1b7efc222273',
  userOnPaytmMembershipPlan: '41cbb1f644ef5ec65b4c7216aac23311',
  userPendingFunds: 'af370a4b7c2adb028a666297aa9ffa28',
  userRecentProjectsAndContests: 'ea394addcb61da312db4ff899767f57d',
  users: 'dcc043a2d2c0e1f6b7fd52e66441232e',
  userSkills: 'e25b853ca911f12c0be653aa7a70b706',
  userTypeInfo: '946dad862050d0198174c3380eb7e91f',
  usersProfile: '0a1d8d99406398b8e192208766e1ba4d',
  usersSelf: '5bdd78cc2d9e773ea431e9c5dd408883',
  verificationAddressDocumentTypes: 'd13b03dc042b753ecea9437010ac4ff8',
  grants: '02e5d55d5945ef6d8f80c9ff2f674fb2',
  verificationIdTypes: '70151aa0c0c75979b269082909b8bf3f',
  verificationFiles: '95b77192f8e35b2ccc158a8d494b723d',
  verificationRequest: 'bc73642503328592cdad638f892acdbc',
  violationReports: 'dbfad1ca25a7e3cc8ee195731a134564',
  webhooks: 'cada0b9dbf7f2dedb9f053882b7d0f87',
  recommendedUsernames: 'c1730888439c6e53b0b7c05b9e7edef2',
  siteStats: '95a8af1926677fb0ed9b8a1de744dd5d',
  twoFactorDetails: 'acd5c0ea84693073d20f94f323178cad',
};
